import React, { useState } from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import { useAuth } from '../../auth/Auth';
import MasonryLayout from '../../common/MasonryLayout';
import Fullview from '../../common/Fullview';
import Avatar from '../../common/Avatar';
import ChallengeLink from '../../common/ChallengeLink';
import { VERY_SMALL_TYPE } from '../../../constants/avatarType.constants';
import { getUserProfileUrl } from '../../../utils/camp.utils';
import Binky from '../../common/Binky';
import { feedViewModel } from "../feed/feed.view.model";

import './scss/image.gallery.scss';
import ShareModal from '../../common/ShareModal';
import GetVerifiedNowModal from '../next_challenge/getVerifiedNowModal';
import { getImageUrl } from '../../../utils/imageUrl.utils';
import OptimizeSignup from '../onboarding/signup_popups/OptimizeSignup';

const ImageGallery = ({
  feedList,
  handleBinky,
  handleScroll,
  handleComment,
  isCampRoom,
}) => {
  const [showFullview, setShowFullview] = useState(false);
  const [fullviewData, setFullviewData] = useState({});
  const [commentList, setCommentList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareModalProps, setShareModalProps] = useState();
  const [showGetVerifiedModal, setShowGetVerifiedModal] = useState(false);
  const [imageLoaded, setImageLoaded] = useState([]);
  // const [fullviewBinky, setFullviewBinky] = useState(null);
  const handleCloseFullview = () => {
    setShowFullview(false);
    handleScroll();
  };
  const handleShowFullview = () => {
    setShowFullview(true);
    handleScroll();
  };

  const { dependent, guardian, school } = useAuth();

  const getComments = (creation_id) => {
    feedViewModel
      .commentList({ creation_id: creation_id })
      .then((res) => {
        setCommentList([...res.data]);
      })
      .catch();
  };

  const setImageLoadedFun = (id) => {
    const temp = [...imageLoaded];
    temp[id] = true;
    setImageLoaded(temp);
  };

  const getFeed = () => {
    const feed = feedList.map((creation) => {
      const data = {
        id: creation.creation_id || creation?.id,
        user: creation.user,
        media: creation.media,
        title: creation.title,
        description: creation.description,
        created_at: creation.created_at,
        binky_id: creation.binky_id,
        binky_count: creation.binky_count,
        comment_count: creation.comment_count,
        challengeId: creation.challenge.id,
        challenge_id: creation.challenge !== '' ? creation.challenge.id : '',
        challenge_title:
          creation.challenge !== '' ? creation.challenge.title : '',
        special_camp: creation.challenge.special_camp,
        restrict: creation?.restrict || false,
      };
      const target =
        dependent && data.user.user_id === dependent.id ? dependent : data.user;

      const userProfileUrl = getUserProfileUrl(target);
      const creator = {
        userProfileUrl,
        id: data.id,
        userName: data.user.username,
        groupName: data.user.profile.group.name,
        teacherId: data.user.profile.group?.group_captain?.id,
        favorites: data.user.profile.favorites,
        firstName: data.user.first_name,
        lastName: data.user.last_name,
        userType: 'dependent',
        schoolName:
          data?.user?.school_details?.school_name ||
          data?.user?.profile?.group?.camp_details?.school_name,
        tribeRequest: data?.user?.profile?.tribe_request_status,
      };
      const avatar = (
        <div className="avatar-container">
          <Avatar
            {...creator}
            type={VERY_SMALL_TYPE}
            shareModal={setShowShareModal}
            setShareModalProps={setShareModalProps}
            schoolDetail={creator.schoolName}
            tribeRequest={creator?.tribeRequest}
          />
        </div>
      );
      const multipleImageNumbering =
        data.media.length > 1 ? (
          <div className="multiple-content-numbering">
            1 / {data.media.length}
          </div>
        ) : (
          <></>
        );
      const showFullviewHandler = () => {
        if (dependent && !guardian) {
          if (!dependent.profile.is_activated) {
            return setShowGetVerifiedModal(true);
          }
          setFullviewData(data);
          // setFullviewBinky(binky);
          handleShowFullview();
          getComments(data.id);
        } else {
          if (!dependent && !guardian && !school) {
            setShowModal(true);
          }
          if (isCampRoom) {
            setFullviewData(data);
            handleShowFullview();
            getComments(data.id);
          }
          localStorage.setItem('kids_login_location', window.location.href);
        }
      };

      const binky = (
        <Binky
          creationId={data.id}
          binkyCountProp={data.binky_count}
          commentCountProp={data.comment_count}
          binkyIdProp={data.binky_id}
          feedList={feedList}
          handleBinky={handleBinky}
          handleComment={handleComment}
          setShowFullview={showFullviewHandler}
          isFullView={false}
        />
      );

      const content = (
        <div className="creation-media">
          <picture className="creation-image">
            <source srcSet={creation.media[0].s480_url} />
            <img
              onClick={showFullviewHandler}
              src={getImageUrl(creation.media[0])}
              onLoad={(e) => setImageLoadedFun(data.id)}
            />
          </picture>
        </div>
      );
      const title = <div className="title">{data.title}</div>;

      return (
        <div
          className="box-container content-wrapper"
          key={data.id}
          style={{ display: imageLoaded[data.id] ? 'block' : 'none' }}
        >
          <div className="image-container">
            {content}
            {binky}
            {multipleImageNumbering}
          </div>
          <div className="middle-container">
            {title}
            {avatar}
          </div>
          <ChallengeLink
            id={data.challenge_id}
            title={data.challenge_title}
            from="feed"
            isSpecial={data?.special_camp?.id ? true : false}
            isRestrict={data?.restrict}
          />
        </div>
      );
    });
    return (
      <div className="image-gallery-feed-masonry-layout">
        {/* <Container> */}
        <Row className="justify-content-md-center">
          <Col className="justify-content-md-center text-center">
            <MasonryLayout minimum="1">{feed}</MasonryLayout>
          </Col>
        </Row>
        {/* </Container> */}
        <Fullview
          show={showFullview}
          setShowFullview={setShowFullview}
          data={fullviewData}
          handleClose={handleCloseFullview}
          feedList={feedList}
          handleBinky={handleBinky}
          handleComment={handleComment}
          commentList={commentList}
          getComments={getComments}
          isFullView={true}
        />
        {showGetVerifiedModal ? (
          <GetVerifiedNowModal
            show={showGetVerifiedModal}
            setShow={setShowGetVerifiedModal}
          />
        ) : (
          ''
        )}
        {/* <GuestRedirectVerification showModal={showModal} setShowModal={setShowModal} /> */}
        <OptimizeSignup showModal={showModal} setShowModal={setShowModal} />
        <ShareModal
          showShareModal={showShareModal}
          setShowShareModal={setShowShareModal}
          shareModalProps={shareModalProps}
        />
      </div>
    );
  };

  return <div>{getFeed()}</div>;
};

export default ImageGallery;
